/**
 * Если `valueOrFn` — функция, вызывает её с `args` и возвращает результат; иначе возвращает значение как есть.
 */
export function callIfFn<T, A extends unknown[]>(valueOrFn: T | ((...args: A) => T), ...args: A): T {
    if (typeof valueOrFn === "function") {
        return (valueOrFn as (...args: A) => T)(...args);
    }
    return valueOrFn;
}
